import { createContext, useState } from "react";
import { CognitoUser, AuthenticationDetails } from "amazon-cognito-identity-js";
import Pool from "../UserPool";

const AccountContext = createContext();
const AccountProvider = (props) => {
  const [user, setUser] = useState(null);
  const [authToken, setAuthToken] = useState(null)

  const getSession = async () =>
    await new Promise((resolve, reject) => {
      const user = Pool.getCurrentUser();
      if (user) {
        user.getSession(async (err, session) => {
          if (err) {
            reject(err);
          } else {
            try {
              const attributes = await new Promise((resolve, reject) => {
                user.getUserAttributes((err, attributes) => {
                  if (err) {
                    reject(err);
                  } else {
                    const results = {};

                    for (let attribute of attributes) {
                      const { Name, Value } = attribute;
                      results[Name] = Value;
                    }
                    // console.log("ACCOUNT CONTEXT", results);
                    resolve(results);
                    setUser(results);
                  }
                });
              });
              const token = session.getIdToken().getJwtToken();
              setAuthToken(token)
              resolve({
                user,
                headers: {
                  Authorization: token,
                },
                ...session,
                ...attributes,
              });
            } catch (err) {
              console.error(err)
              reject(err)
            }
          }
        });
      } else {
        reject();
      }
    });

  // basic authentication feature calling CognitoUser with username,password and pool
  const authenticate = async (Username, Password) =>
    await new Promise((resolve, reject) => {
      const user = new CognitoUser({ Username, Pool });
      const authDetails = new AuthenticationDetails({ Username, Password });

      user.authenticateUser(authDetails, {
        onSuccess: (data) => {
          console.log("onSuccess:", data);
          resolve(data);
        },

        onFailure: (err) => {
          console.error("onFailure:", err);
          reject(err);
        },

        newPasswordRequired: (userAttributes, requiredAttributes) => {
          console.log("newPasswordRequired:", userAttributes);
          console.log("requiredAttributes", requiredAttributes)
          userAttributes = { ...userAttributes, "NEW_PASSWORD_REQUIRED": true, user: user }
          console.log(userAttributes)
          resolve(userAttributes);
        },
      });
    });

  const confirmRegistration = async (Username, code) =>
    await new Promise((resolve, reject) => {
      const user = new CognitoUser({ Username, Pool });
      user.confirmRegistration(code, false, (err, result) => {
        console.log(err);
        console.log(result);
        if (err) {
          reject(err);
        } else {
          resolve(result);
        }
      });
    });

  const resendConfirmationCode = async (Username) =>
    await new Promise((resolve, reject) => {
      const user = new CognitoUser({ Username, Pool });
      user.resendConfirmationCode((err, result) => {
        console.log(err);
        console.log(result);
        if (err) {
          reject(err);
        } else {
          resolve(result);
        }
      });
    });

  const forgotPassword = async (Username) =>
    await new Promise((resolve, reject) => {
      const user = new CognitoUser({ Username, Pool });
      user.forgotPassword({
        onSuccess: (data) => {
          // successfully initiated reset password request
          console.log("CodeDeliveryData from forgotPassword: " + data);
          resolve(data);
        },
        onFailure: (err) => {
          reject(err);
        },
      });
    });

  const newPasswordChallenge = async (user, newPassword) =>
    await new Promise((resolve, reject) => {
      console.log(user)
      console.log(user)
      // user.completeNewPasswordChallenge(newPassword, sessionUserAttributes)
      user.completeNewPasswordChallenge(newPassword, null, {
        onSuccess: (result) => {
          console.log("NEW PASSWORD COMPLETED: ");
          console.log(result);
          resolve(result)
        },
        onFailure: (err) => {
          console.log(err);
          reject(err)
        }
      });
    });

  const confirmPassword = async (Username, verificationCode, newPassword) =>
    await new Promise((resolve, reject) => {
      const user = new CognitoUser({ Username, Pool });
      user.confirmPassword(verificationCode, newPassword, {
        onSuccess() {
          resolve("Password confirmed!");
        },
        onFailure(err) {
          reject(err);
        },
      });
    });

  const changePassword = async (user, oldPassword, newPassword) =>
    await new Promise((resolve, reject) => {
      user.changePassword(oldPassword, newPassword, (err, result) => {
        console.log(err);
        console.log(result);
        if (err) {
          reject(err);
        } else {
          resolve(result);
        }
      });
    });

  const logout = () => {
    const user = Pool.getCurrentUser();
    if (user) {
      user.signOut();
    }
  };

  return (
    <AccountContext.Provider
      value={{
        authenticate,
        confirmRegistration,
        resendConfirmationCode,
        forgotPassword,
        confirmPassword,
        changePassword,
        newPasswordChallenge,
        getSession,
        logout,
        user,
        authToken
      }}
    >
      {props.children}
    </AccountContext.Provider>
  );
};

export { AccountProvider, AccountContext };
